// extracted by mini-css-extract-plugin
export default {"container":"PlanCard_container__GUfBa","pricePerMonth":"PlanCard_pricePerMonth__6opfN","text":"PlanCard_text__0VlUG"};